<div class="menu-container">
  <div *ngFor="let navigationItem of navigationItems" class="menu-card-container" [ngClass]="{'disabled': navigationItem.disabled, 'hide': !navigationItem.title}">    
    <a [href]="navigationItem.externalURL" *ngIf="navigationItem.externalURL && !navigationItem.disabled">
      <div class="menu-card">
        <div class="menu-header">
          <div>
            <div class="center-line"></div>
            <div class="icon-container"><span class="{{navigationItem.icon}}"></span></div>
          </div>
        </div>
        <div class="menu-footer">
          <div>{{navigationItem.title}}</div>
          <div class="footer-description">{{navigationItem.description}}</div>
        </div>
      </div>
    </a>
    
    <a [routerLink]="['/'+navigationItem.path]" *ngIf="navigationItem.path && !navigationItem.disabled">
      <div class="menu-card">
        <div class="menu-header">
          <div>
            <div class="center-line"></div>
            <div class="icon-container"><span class="{{navigationItem.icon}}"></span></div>
          </div>
        </div>
        <div class="menu-footer">
          <div>{{navigationItem.title}}</div>
          <div class="footer-description">{{navigationItem.description}}</div>
        </div>
      </div>
    </a>

    <a *ngIf="navigationItem.disabled">
      <div class="menu-card">
        <div class="menu-header">
          <div>
            <div class="center-line"></div>
            <div class="icon-container"><span class="{{navigationItem.icon}}"></span></div>
          </div>
        </div>
        <div class="menu-footer">
          <div>{{navigationItem.title}}</div>
          <div class="footer-description">{{navigationItem.description}}</div>
        </div>
      </div>
    </a>
  </div>
</div>